import { MaterialItem, WeekModule } from "@/interface/viewMaterial";
import { API_BASE_URL } from "@/utils/api";
import { Dispatch, SetStateAction } from "react";

export const dataMaterial = async (
  courseId: string | number,
  token: string | null,
  setGroupedMaterials: Dispatch<SetStateAction<WeekModule[]>>,
  setActiveMaterial: Dispatch<SetStateAction<MaterialItem | null>>,
) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/courses/materials/${courseId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    if (response.ok) {
      const rawData: MaterialItem[] = await response.json();

      const groups: { [key: string]: MaterialItem[] } = {};
      rawData.forEach((item) => {
        if (!groups[item.week_title]) {
          groups[item.week_title] = [];
        }
        groups[item.week_title].push(item);
      });

      const modules: WeekModule[] = Object.keys(groups).map((week) => ({
        weekTitle: week,
        items: groups[week],
      }));

      setGroupedMaterials(modules);

      if (rawData.length > 0) {
        setActiveMaterial(rawData[0]);
      }
    }

    return response;
  } catch (error: any) {
    console.error(
      "Gagal memuat materi:",
      error.response?.data?.message || error.message,
    );
    throw error;
  }
};
